export function getRouterList() {
    return [
        {
            name: 'Index',
            title: '首页',
            children: []
        },
        {
            name: 'New',
            title: '新闻',
            children: []
        },
        {
            name: 'SpaceCapsule',
            title: '智能民宿太空舱',
            children: []
        },
        {
            name: '',
            title: '产品中心',
            children: [
                {
                    name: '',
                    title: '软件APP',
                    children: [
                        {title: '腾宇慧住APP', name: 'Tyhzapp', desc: '打造一条龙服务无人酒店'},
                        {title: '腾宇开店APP', name: 'Tygjapp', desc: '打造移动数字化酒店管理'},
                        {title: '掌上管家APP', name: 'Zsgjapp', desc: '打造移动数字化酒店管理'},
						{title: '腾宇竞拍APP', name: 'tyjpapp', desc: '打造多商户竞拍平台'}
                    ],
                },
                {
                    name: '',
                    title: '硬件产品',
                    children: [
                        {title: '酒店客房', name: 'Jdkf', desc: '以手机为中心酒店去前台化'},
                        {title: '智能家居', name: 'Znjj', desc: '改变不一样的生活体验'}
                    ],
                }
            ]
        },
        {
            name: 'Agent',
            title: '招代理商',
            children: []
        },
        {
            name: 'Jobxq',
            title: '人才招聘',
            children: []
        },
        {
            title: '关于我们',
            name: 'Company',
            children: [
                {
                    name: '',
                    title: '',
                    children: [
                        {name: 'About', title: '公司介绍', desc: '浙江腾宇物联科技有限公司'},
                        {name: 'Contact', title: '联系我们', desc: '我们致力于为您提供丰富的服务咨询'},
                        {name: 'New', title: '腾宇动态', desc: '了解腾宇的全球视野'}
                    ],
                }

            ]

        },
    ]
}